import { createStore } from 'satcheljs';
import ExportMailboxOptionStore from './schema/ExportMailboxOptionStore';

export default createStore<ExportMailboxOptionStore>('exportMailboxOption', {
    isExportMailboxRequestMade: undefined,
    requestStatus: undefined,
    downloadLink: undefined,
});
